
import Main from './Components/Main'
import './styles.scss';

const MyPage = (props, ref) => {
    return <div className={"bpl-container"}>
        <Main />
    </div>
}

export default MyPage